import { render, staticRenderFns } from "./BannersTable.vue?vue&type=template&id=1b0fa705&scoped=true"
import script from "./BannersTable.vue?vue&type=script&lang=js"
export * from "./BannersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0fa705",
  null
  
)

export default component.exports